<template>
  <div class="modal">
    <div class="impersonation__container">
      <div class="block">
        <div class="block__header">
          <div class="block__tools">
            <button class="icon-button close-green" @click="closeImpersonation"></button>
          </div>
          <h2 class="block__title">{{ getResource('FoundUsers') }}</h2>
        </div>
        <div class="block__content block__content--impersonation" v-if="users">
          <table class="impersonation-table">
            <tr>
              <th>Name:</th>
              <th>E-mail:</th>
              <th>Company:</th>
              <th>Country:</th>
              <th></th>
            </tr>
            <tr v-for="user in users[pageNumber]" v-if="users">
              <td>{{user.Name}}</td>
              <td>{{user.Email}}</td>
              <td>{{user.Company}}</td>
              <td>{{user.Country}}</td>
              <td><button class="button" v-on:click="changeUser(user)">Go</button></td>
            </tr>
          </table>
          <div class="pagination pagination--left" v-if="users.length > 1">
            <button class="icon-button prev-green" @click="prev"></button>
            <span>{{pageNumber + 1}} / {{users.length}}</span>
            <button class="icon-button next-green" @click="next"></button>
          </div>
        </div>
        <loading v-else class="impersonation_loading"></loading>
      </div>
    </div>
  </div>
 </template>
<script>
import Loading from "../../shared/Loading";
import { changeUser, closeImpersonation, openImpersonation } from "./ImpersonationActions";
import { getResource } from "../../vuex/helpers";

export default {
  vuex: {
    getters: {
      showModal: state => state.showModal,
      users: state => state.loadedUsers
    },
    actions: { closeImpersonation, openImpersonation, changeUser, getResource }
  },
  components: { Loading },
  data: function () {
    return {
      pageNumber: 0
    };
  },
  methods: {
    next () {
      this.pageNumber = Math.min(this.users.length - 1, this.pageNumber + 1);
    },
    prev () {
      this.pageNumber = Math.max(0, this.pageNumber - 1);
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .modal {
  	position: fixed;
  	top: 0;
  	left: 0;
  	right: 0;
  	bottom: 0;
  	background: rgba(1,1,1,0.9);
    z-index: 2000;
  }

  .impersonation-table{
    width: 100%;

    th{
      color: $green;
      text-align: left;
      font-weight: normal;
      padding-bottom: 10px;
    }

    td{
      padding: 5px 20px 5px 0;
      
      &:last-child{
        padding-right: 0;
        width: 110px;
      }
    }
  }

  .block__content--impersonation{
    @include clear-fix;
    padding-bottom: 30px;
    color: $white;
  }

  .pagination--left{
    margin-top: 20px;
    float: left !important;
  }

	.impersonation__container {
		border: 0px solid transparent;
    box-sizing: border-box;
    display: block;
		margin: 0 auto;
		margin-top:10%;
		overflow: hidden;
    width: 70%;
	}

  @media only screen and (max-height: 768px)
  {
	.impersonation__container {
		width: 90%;
		margin-top: 5%;
	}
	
	.impersonation__container h2 {
		font-size: 25px;
	}	
	
	.block__content {
		padding: 30px;
	}
	
	.block__header {
		padding: 15px 40px 10px;
	}
	
	.impersonation__container .icon-button {
		width: 40px;
		height: 35px;
	}
	
    .impersonation__container .close-green:before{
		left: 10px;
    }	
  }	
	
  .impersonation_loading{
    background: $brown_light;
    width: 100%;
    height: 650px;
    float: left;
  }

  .close-green{
    position: relative;

    &:before{
      content: "+";
      color: $green;
      font-size: 30px;
      line-height: 30px;
      position: absolute;
      left: 18px;
      top: 3px;

      transform: rotate(45deg);
    }
  }
</style>


// WEBPACK FOOTER //
// Impersonation.vue?f6f06770